import type { AllRouteEndpoints } from "../routeTypes";

export const appsAppIdPushCredential = "/apps/:app_id/push_credential";

export const appsAppIdPushCredentialCacheKeys: AllRouteEndpoints[] = [
  "/apps/:app_id/push_credential",
  "/apps/aggregate_push_credential_info",
  "/apps/app_group",
];
